/**
 * Newsletter consent wording, by version. Each opt-in records the version
 * of the text the person agreed to (`newsletter_subscriber.consent_version`),
 * so this map is the record of what each version said. Never edit a
 * published entry: add a new version and point the current one at it.
 */

// Sign-up checkbox (mobile and dashboard). Clients send this version.
const NEWSLETTER_CONSENT_VERSION = '2026-10-06';

const NEWSLETTER_CONSENT_TEXTS = {
  '2026-10-06':
    'Send me Careit news and updates. Optional. You can unsubscribe at any time.',
  // Account settings → Notifications → Newsletters switch.
  'account-2026-10-18':
    'Newsletters: occasional product updates, tips and news from Careit. Emails about your rescues, food runs and account, including important service announcements, are not affected by this setting.',
  // Double opt-in confirmation email (website sign-ups and imports).
  'confirm-2026-10-18':
    'Your email address was added to the Careit mailing list. Press the button below to confirm that you want news and updates from Careit. [Yes, subscribe me]',
  // careit.com footer form before website sign-ups moved to the platform
  // (single opt-in), for subscribers brought over by
  // apps/backend/scripts/importWebsiteNewsletterSubscribers.js.
  'website-legacy':
    'Stay Updated. Get the latest news on food rescue and community impact. [Email] [Subscribe]',
};

// The version recorded for each place someone can opt in.
const NEWSLETTER_CONSENT_VERSIONS = {
  signup: NEWSLETTER_CONSENT_VERSION,
  account: 'account-2026-10-18',
  confirm: 'confirm-2026-10-18',
  websiteLegacy: 'website-legacy',
};

const isNewsletterConsentVersion = (version) =>
  Object.prototype.hasOwnProperty.call(NEWSLETTER_CONSENT_TEXTS, version);

module.exports = {
  NEWSLETTER_CONSENT_VERSION,
  NEWSLETTER_CONSENT_TEXTS,
  NEWSLETTER_CONSENT_VERSIONS,
  isNewsletterConsentVersion,
};
